import "./App.css";
import Header from "./components/Header";
import { Routes, Route } from "react-router-dom";
// import Simulation from "./components/Simulation";
import Home from "./Pages/Home";
import QuiSommeNous from "./Pages/LudoBlue/QuiSommeNous";
import Itinerance from "./Pages/LudoBlue/Itinerance";
import LudoBlue from "./Pages/LudoBlue/LudoBlue";
import Bibliographie from "./Pages/LudoBlue/Bibliographie";
import Game from "./Pages/Game";
import GameList from "./Pages/GameList";
import Demande from "./Pages/Demande";
import Temporaires from "./Pages/Temporaires";
import JeuxPourTous from "./Pages/Animations/JeuxPourTous";
import GrandJeux from "./Pages/Animations/GrandJeux";
import JeuxCooperatifs from "./Pages/Animations/JeuxCooperatifs";
import Particuliers from "./Pages/PretJeu/Particuliers";
import Structures from "./Pages/PretJeu/Structures";
import GrandJeuxPret from "./Pages/PretJeu/GrandJeuxPret";
import CarteCadeau from "./Pages/PretJeu/CarteCadeau";
import Animations from "./Pages/Animations/Animations";
import PretJeux from "./Pages/PretJeu/PretJeux";



function App() {

  return (
    <div    >
      <Header />
   
      <div className="p-3">
        <Routes>
          <Route exact path="/" element={<Home />} />
          {/* <Route path="/login" element={<Simulation setUser={setUser} />} /> */}
          <Route exact path="/LudoBlue" element={<LudoBlue />} />
          <Route exact path="/qui" element={<QuiSommeNous />} />
          <Route path="/itinerance" element={<Itinerance />} />
          <Route path="/bliographie" element={<Bibliographie />} />
          <Route path="/jeux" element={<GameList />} />
          <Route path="/jeux/:id" element={<Game />} />
          <Route path="/demande" element={<Demande />} />
          <Route path="/temporaires" element={<Temporaires />} />
          <Route path="/animations" element={<Animations />} />
          <Route path="/JeuxPourTous" element={<JeuxPourTous />} />
          <Route path="/PretJeux" element={<PretJeux />} />
          <Route path="/GrandJeux" element={<GrandJeux />} />
          <Route path="/JeuxCooperatifs" element={<JeuxCooperatifs />} />
          <Route path="/Particuliers" element={<Particuliers />} />
          <Route path="/Structures" element={<Structures />} />
          <Route path="/GrandJeuxPret" element={<GrandJeuxPret />} />
          <Route path="/CarteCadeau" element={<CarteCadeau />} />
        </Routes>
      </div>
    </div>
  );
}

export default App;
